import ShareMsgBase from './A_G.ShareMsgBase';

class MsgFriendshipChestJoined extends ShareMsgBase {
  /**
   * The message that is sent to the inviter when the invitee joins the game
   * @param {string} user1Photo
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1Photo, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(271, 135, user1Photo, 0, 140, null);

    this.bg = this._addExtImage(0, 0, 'img/Msg_FriendChest_Joined.png', 0, null, null);

    this.thanksforyourhelp = this.add(new G.Text(342.5, 68.5,
      OMT.language.getText('Friendship Chest').toUpperCase(), 'msg-friendChestJoined', 0.5, 611, 113, true, 'center'));

    this._objectLoadComplete();
  }
}

G.MsgFriendshipChestJoined = MsgFriendshipChestJoined;
